<div class='image-wrapper' *ngIf="fileMap.width && fileMap.height">
  <img *ngIf="isImage" [src]="data.file.uri" (load)="setScale($event)" style="object-fit: contain" fxFlex>
  <video *ngIf="isVideo" [src]="data.file.uri" (load)="setScale($event)" controls autoplay muted
    style="object-fit: contain; height: 100%;"></video>
  <svg [attr.viewBox]="'0 0 '+ fileMap.width + ' ' + fileMap.height" xmlns="http://www.w3.org/2000/svg" class="zone-map">
    <ng-container *ngFor="let zone of zones">
      <circle *ngIf="zone.shape === 'Circle'" 
        [ngClass]="{'selected': zone.selected}"
        (pointerdown)="onMovePointerDown($event, zone)" (pointerup)="onMovePointerUp($event, zone)" (pointercancel)="onMovePointerUp($event, zone)"
        [attr.cx]="zone.x" [attr.cy]="zone.y" [attr.r]="zone.radius">
      </circle>
      <rect *ngIf="zone.shape === 'Rect'" 
        [ngClass]="{'selected': zone.selected}"
        (pointerdown)="onMovePointerDown($event, zone)" (pointerup)="onMovePointerUp($event, zone)" (pointercancel)="onMovePointerUp($event, zone)"
        [attr.x]="zone.x" [attr.y]="zone.y" [attr.width]="zone.width" [attr.height]="zone.height">
      </rect>
      <ng-container *ngIf="zone.selected">
        <g>
        <circle [attr.r]="5 * handleScale" class="handle" [attr.cx]="zone.x + (zone.width || zone.radius)" [attr.cy]="zone.y - (zone.radius ? zone.radius : 0)" 
          (pointerdown)="onResizePointerDown($event, zone, 'TR')" (pointerup)="onResizePointerUp($event, zone)" (pointercancel)="onResizePointerUp($event, zone)"></circle>
          <circle [attr.r]="5 * handleScale" class="handle" [attr.cx]="zone.x - (zone.radius ? zone.radius : 0)" [attr.cy]="zone.y - (zone.radius ? zone.radius : 0)" fill="white"
          (pointerdown)="onResizePointerDown($event, zone, 'TL')" (pointerup)="onResizePointerUp($event, zone)" (pointercancel)="onResizePointerUp($event, zone)"></circle>
          <circle [attr.r]="5 * handleScale" class="handle" [attr.cx]="zone.x - (zone.radius ? zone.radius : 0)" [attr.cy]="zone.y + (zone.height || zone.radius)" 
          (pointerdown)="onResizePointerDown($event, zone, 'BL')" (pointerup)="onResizePointerUp($event, zone)" (pointercancel)="onResizePointerUp($event, zone)"></circle>
          <circle [attr.r]="5 * handleScale" class="handle" [attr.cx]="zone.x + (zone.width || zone.radius) " [attr.cy]="zone.y + (zone.height || zone.radius)"
          (pointerdown)="onResizePointerDown($event, zone, 'BR')" (pointerup)="onResizePointerUp($event, zone)" (pointercancel)="onResizePointerUp($event, zone)"></circle>
          </g>
      </ng-container>
    </ng-container>
  </svg>
</div>
<ng-container *ngIf="data?.file?.fileContentType === 'application/pdf'">
  <embed [src]="safeUrl" type="application/pdf" class="w-100" />
</ng-container>

<!-- Form -->
<mat-card class="interaction-list" fxFlex fxLayout="column" [style.overflow]="'auto'" *ngIf="fileMap.width && fileMap.height && !data.isPreviewOnly">
  <mat-card-header>
    <div class="w-100" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="5px">
        <mat-chip>Width: {{fileMap.width}}</mat-chip>
        <mat-chip>Height: {{fileMap.height}}</mat-chip>
        <mat-icon color="accent" [matTooltip]="'You can use arrow keys to nudge the selected zone by 1px (or 10px with Shift)'">tips_and_updates</mat-icon>
      </div>
      <button color="accent" mat-stroked-button (click)="onAddZone()"><mat-icon>add</mat-icon>Add</button>
    </div>
  </mat-card-header>
  <mat-card-content fxFlex>
    <div fxLayoutGap="10px" fxLayout="column" class="w-100">
      <ng-container *ngFor="let zone of zones">
        <mat-card class="contrast" [ngClass]="{'active': zone.selected}" tabindex="0" (focusin)="onZoneSelected(zone)">
          <mat-card-content class="zone-item">
            <button mat-icon-button color="accent" type="button" matTooltip="Change shape" (click)="onSwapShape(zone)"
              [style.grid-area]="'select'">
              <mat-icon>{{zone.shape === 'Rect' ? 'rectangle' : 'circle'}}</mat-icon>
            </button>
            <div [style.grid-area]="'xy'">
              <small>X</small><input matInput type="number" [(ngModel)]="zone.x">
              <small>Y</small><input matInput type="number" [(ngModel)]="zone.y">
            </div>
            <div *ngIf="zone.shape === 'Rect'" [style.grid-area]="'shape'">
              <small>W</small><input matInput type="number" [(ngModel)]="zone.width">
              <small>H</small><input matInput type="number" [(ngModel)]="zone.height">
            </div>
            <div *ngIf="zone.shape === 'Circle'" class="h-100 w-100" [style.grid-area]="'shape'">
              <small>Radius</small><input matInput type="number" [(ngModel)]="zone.radius">
            </div>
            <div [style.grid-area]="'action-select'" class="h-100 w-100">
              <small>Action</small>
              <mat-select [(ngModel)]="zone.targetType" placeholder="Select Action">
                <mat-option value="FileVault">
                  Open File →
                </mat-option>
              </mat-select>
            </div>
            <div *ngIf="zone.targetType === 'FileVault'" class="h-100 w-100" [style.grid-area]="'action'">
              <small>File</small>
              <div role="button" class="custom-menu-btn marketing-file-thumbnail" [matMenuTriggerFor]="fileSelect">
                <ng-container *ngIf="!zone.target">
                  <mat-icon class="article-icon">add</mat-icon>
                </ng-container>
                <ng-container *ngIf="zone.target">
                  <ng-container *ngTemplateOutlet="thumbnail; context: {material: zone.target}"></ng-container>
                </ng-container>
              </div>
              <mat-menu #fileSelect="matMenu" [panelClass]="'gallery-panel'" class="gallery-panel">
                <mat-menu-item *ngFor="let file of data.resources" (click)="zone.target = file">
                  <ng-container *ngTemplateOutlet="thumbnail; context: {material: file}"></ng-container>
                </mat-menu-item>
              </mat-menu>
            </div>
            <button mat-icon-button color="warn" type="button" (click)="onRemoveZone(zone)" matTooltip="Remove zone"
              [style.grid-area]="'btn'"><mat-icon>delete</mat-icon></button>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>
  </mat-card-content>
  <mat-card-footer fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="w-100 m-0 p-10">
    <button *ngIf="!!fileVaultRef" mat-icon-button (click)="onRemove()" color="warn" matTooltip="Remove File">
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-flat-button color="primary" (click)="onSave()">
      <mat-icon>save</mat-icon>Save
    </button>
    <button mat-stroked-button mat-dialog-close cdkFocusInitial>
      <mat-icon>close</mat-icon>Cancel
    </button>
  </mat-card-footer>
</mat-card>

<ng-template #thumbnail let-material="material">
  <div class="marketing-file-thumbnail">
    <img *ngIf="material.localType === FileType.IMAGE" [src]="material.uri">
    <ng-container *ngIf="material.localType === FileType.VIDEO">
      <img *ngIf="material.thumbnail" [src]="material.thumbnail.uri">
      <mat-icon class="video-icon">ondemand_video</mat-icon>
    </ng-container>
    <mat-icon class="article-icon" *ngIf="material.localType === FileType.PDF">article</mat-icon>
    <div class="bigram" *ngIf="material.localType === FileType.PDF" [matTooltip]="material.fileName">{{material.bigram}}
    </div>
  </div>
</ng-template>